import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59160414"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "redpack-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_redpack_info_symbol = _resolveComponent("redpack-info-symbol")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, [
      (_ctx.redPackBasicInfo.title)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.redPackBasicInfo.title), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode("~")
          ], 64))
    ]),
    _createVNode(_component_redpack_info_symbol, {
      chainId: _ctx.chainId,
      redPackId: _ctx.redPackId
    }, null, 8, ["chainId", "redPackId"])
  ]))
}